import { isFreebieSkuId } from "@/lib/freebieCalc";

// Canonical brand list (mirrors backend OrderItem.brand Literal).
export const CANONICAL_BRANDS = ["Wellcore", "Dynamite", "Okami", "YouWeFit", "Zero Sugar", "OSMO"];

// Brand-wise effective discount for a SINGLE quotation. This is the authoritative logic used on
// the Quotation Detail page: includes eligible freebies in brand MRP, excludes exclude_from_discount
// lines (shakers/carry bags). Returns { [brand]: { mrp, saleMrp, freebieMrp, invoice, discount } }
// only for brands that have eligible MRP > 0. Kept identical everywhere so list views match details.
// Freebie whitelist (app_settings.freebie_skus, hydrated by App.js via freebieCalc) is the source of
// truth for what counts as a freebie and is ALWAYS excluded from discount %; an explicit freebieSkus
// arg can override for isolated/test usage.
export function calculateBrandStats(saleItems, freebieItems, freebieSkus) {
  const isFreebieSku = freebieSkus != null
    ? ((it) => (freebieSkus instanceof Set ? freebieSkus : new Set(freebieSkus)).has((it.sku_id || "").trim()))
    : ((it) => isFreebieSkuId(it.sku_id));
  const items = (saleItems || []).filter((it) => !isFreebieSku(it));
  const freebies = (freebieItems || []).filter((it) => !isFreebieSku(it));
  if (items.length === 0 && freebies.length === 0) return {};

  const brandStats = {};
  CANONICAL_BRANDS.forEach((brand) => {
    const brandEligibleSaleItems = items.filter((it) => it.brand === brand && !it.exclude_from_discount);
    const brandEligibleFreebieItems = freebies.filter((it) => it.brand === brand && !it.exclude_from_discount);

    const brandSaleMrp = brandEligibleSaleItems.reduce((s, it) => s + (it.total_mrp || 0), 0);
    const brandFreebieMrp = brandEligibleFreebieItems.reduce((s, it) => s + (it.total_mrp || 0), 0);
    const brandTotalMrp = brandSaleMrp + brandFreebieMrp;
    const brandInvoice = brandEligibleSaleItems.reduce((s, it) => s + (it.invoice_value || 0), 0);
    const brandDiscount = brandTotalMrp > 0 ? ((brandTotalMrp - brandInvoice) / brandTotalMrp) * 100 : 0;

    if (brandTotalMrp > 0) {
      brandStats[brand] = { mrp: brandTotalMrp, saleMrp: brandSaleMrp, freebieMrp: brandFreebieMrp, invoice: brandInvoice, discount: brandDiscount };
    }
  });
  return brandStats;
}
